import { BlockedAccessScreen } from '@hero/web-components';
import { useCurrentUser } from '@hero/hooks-shared';
import { useLogoutManager, useNav } from '@hero/web-hooks';

export default function OrgBlockedPage() {
  const { user } = useCurrentUser();
  const { logout } = useLogoutManager();
  const { getParams } = useNav();
  const { orgName } = getParams('org_blocked');

  return (
    <BlockedAccessScreen
      kind="org"
      orgName={orgName}
      phone={user?.phone}
      onSignOut={logout}
    />
  );
}
